import '.bu{position:relative;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.ff{font-size:0.75rem;}.ssr-plugin'
import '.fg{line-height:normal;}.ssr-plugin'
import '.fh{top:-0.25rem;}.ssr-plugin'
import '.fi{right:-0.5rem;}.ssr-plugin'
import '.fj{background-color:var(--gray-100);}.ssr-plugin'
import '.fk{border-radius:0.35rem;}.ssr-plugin'
import '.fl{width:0.75rem;}.ssr-plugin'
import '.fm{height:0.75rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  faPaperclip,
  type IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef, ChangeEvent } from 'react'

export type FileSelectorProps = {
  icon?: IconDefinition
  filesSelected?: number
  maxFiles?: number
  maxSizeMB?: number
  allowedFileTypes?: string[]
  iconStyle?: Style
  containerStyle?: Style
  onFileSelectionUpdated: (files: File[]) => void
  disabled?: boolean
}

export const FileSelector = ({
  icon,
  filesSelected = 0,
  maxFiles = 1,
  maxSizeMB = 5,
  allowedFileTypes = ['image/jpeg', 'image/png'],
  iconStyle,
  containerStyle,
  onFileSelectionUpdated,
  disabled = false,
}: FileSelectorProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const onFileUploadClicked = () => {
    if (!disabled) {
      fileInputRef.current?.click()
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files: File[] = []
    const maxSizeBytes = maxSizeMB * 1024 * 1024
    for (const file of event.target.files) {
      if (files.length === maxFiles) {
        break
      }
      if (!allowedFileTypes.includes(file.type)) {
        continue
      }
      if (file.size > maxSizeBytes) {
        continue
      }
      files.push(file)
    }
    onFileSelectionUpdated(files)
  }

  return (
    <>
      <styled.div className="bu"
        onClick={onFileUploadClicked}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          ...containerStyle,
        }}
      >
        <FontAwesomeIcon icon={icon ?? faPaperclip} style={iconStyle} />
        {filesSelected > 0 && (
          <span className="l ff fg fh fi fj fk fl fm a c g"
          >
            {filesSelected}
          </span>
        )}
      </styled.div>

      <input
        type="file"
        multiple={maxFiles > 1}
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={disabled}
        style={{ display: 'none' }}
      />
    </>
  )
}
